var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M558.545455 570.181818a174.545455 174.545455 0 0 1 174.312727 165.236364l0.232727 9.309091v69.818182a34.909091 34.909091 0 0 1-69.492364 4.747636l-0.325818-4.747636V744.727273a104.727273 104.727273 0 0 0-97.559272-104.494546L558.545455 640H279.272727a104.727273 104.727273 0 0 0-104.494545 97.559273L174.545455 744.727273v69.818182a34.909091 34.909091 0 0 1-69.492364 4.747636L104.727273 814.545455V744.727273a174.545455 174.545455 0 0 1 165.236363-174.312728l9.309091-0.232727h279.272728z m253.067636 5.632a174.545455 174.545455 0 0 1 130.699636 159.790546l0.232728 9.122909v69.818182a34.909091 34.909091 0 0 1-69.492364 4.747636l-0.325818-4.747636V744.727273a104.727273 104.727273 0 0 0-78.522182-101.282909 34.909091 34.909091 0 1 1 17.408-67.630546zM418.909091 151.272727a174.545455 174.545455 0 1 1 0 349.090909 174.545455 174.545455 0 0 1 0-349.090909z m253.021091 5.585455a174.545455 174.545455 0 0 1 0 338.245818 34.909091 34.909091 0 1 1-17.314909-67.677091 104.727273 104.727273 0 0 0 0-202.891636 34.909091 34.909091 0 1 1 17.314909-67.630546zM418.909091 221.090909a104.727273 104.727273 0 1 0 0 209.454546 104.727273 104.727273 0 0 0 0-209.454546z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff15);
export default __webpack_public_path__ + "static/media/staff-15.2d9650186cc5ec32ebdeb7b075ba761e.svg";
export { ForwardRef as ReactComponent };